export default __webpack_public_path__ + "static/media/allianz-logo.bc534206.png";